















import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { Department, departmentApis } from '../../api';
import * as _ from 'lodash';

@Component
export default class DepartmentSelect extends Vue {
  @Prop({ default: () => null }) department!: Department | null;
  @Prop({ default: () => false }) external!: boolean;
  selected: Department | null = null;
  departments: Array<Department> | null = null;
  loading = false;
  debounceSearch!: (name: string) => void;

  created() {
    this.debounceSearch = _.debounce(this.refresh, 150);
  }

  async mounted() {
    this.selected = this.department;
    this.$watch('department', d => {
      this.selected = d;
    });
    await this.refresh('');
  }

  async refresh(name: string) {
    this.departments = await departmentApis.search(name, this.external);
  }

  selectDepartment(d: Department | null) {
    this.$emit('input', (d as Department).id);
    this.$emit('change', d);
  }

  title(d: Department) {
    let label = d.name;
    if (d.parent) {
      label = d.parent.name + '/' + label;
    }
    return label;
  }
}
